var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_vm._v(" "+_vm._s(_vm.stateSync)+" "),_c('div',[_c('router-view')],1),_c('Internet')],1)}
var staticRenderFns = []

export { render, staticRenderFns }